/**
 * @file: useCanSeeServiceRecords.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { OrgUserRoleHelper } from '@euler/functions/OrgUserRoleHelper';
import { useStoreConfiguration } from '@euler/functions/useStoreConfiguration';
import { useCurrentUserRole } from '@euler/functions/user/useCurrentUserRole';

/**
 * Whether the signed-in role may see service records (the History tab): a
 * store may restrict them to some roles.
 */
export function useCanSeeServiceRecords(): boolean {
  const storeConfiguration = useStoreConfiguration();
  const role = useCurrentUserRole();
  const restricted = storeConfiguration.restrictedRolesForServiceRecords;
  return (
    !restricted?.length || new OrgUserRoleHelper(role).matchesAny(restricted)
  );
}
